import { datadogRum } from '@datadog/browser-rum';

export * from './ddGlobalSessionId';

export enum AUTHENTICATION_ACTIONS {
  // A user is redirected to the logout route from the AuthContextProvider
  AUTH_CONTEXT_REDIRECT_TO_LOGOUT = 'AUTH_CONTEXT_REDIRECT_TO_LOGOUT',
  // JWTs are cleared from storage
  AUTH_DATA_CLEARED = 'AUTH_DATA_CLEARED',
  // JWTs are written to storage
  AUTH_DATA_SET = 'AUTH_DATA_SET',
  // JWTs are updated in storage
  AUTH_DATA_UPDATED = 'AUTH_DATA_UPDATED',
  // A tab acquires the token refresh lock and becomes the follower
  CROSS_TAB_TOKEN_REFRESH_FOLLOWER_INITIALIZED = 'CROSS_TAB_TOKEN_REFRESH_FOLLOWER_INITIALIZED',
  // A tab acquires the token refresh lock and becomes the leader
  CROSS_TAB_TOKEN_REFRESH_LEADER_INITIALIZED = 'CROSS_TAB_TOKEN_REFRESH_LEADER_INITIALIZED',
  // A follower tab successfully resolves the token refresh promise
  CROSS_TAB_FOLLOWER_RESOLVED = 'CROSS_TAB_FOLLOWER_SUCCESSLY_RESOLVED',
  // A follower tab fails to resolve the token refresh promise
  CROSS_TAB_FOLLOWER_REJECTED = 'CROSS_TAB_FOLLOWER_REJECTED',
  // A tab is waiting for a cross-tab refresh to complete
  CROSS_TAB_REFRESH_IN_PROGRESS = 'CROSS_TAB_REFRESH_IN_PROGRESS',
  // A user is redirected to the logout route from the ApolloLink chain
  GRAPHQL_REDIRECT_TO_LOGOUT = 'GRAPHQL_REDIRECT_TO_LOGOUT',
  // Track the removal of legacy cookies, scoped to .springhealth.com
  OLD_DOMAIN_COOKIE_REMOVED = 'OLD_DOMAIN_COOKIE_REMOVED',
  // A user is redirected to the logout route from the usePageAccess hook
  PAGE_ACCESS_REDIRECT_TO_LOGOUT = 'PAGE_ACCESS_REDIRECT_TO_LOGOUT',
  // AuthContextProvider loads, including via browser refreshes. Not a session in the DD sense,
  // but keeping the name for parity with Compass' action names.
  SESSION_BEGIN = 'SESSION_BEGIN',
  // A refresh token has expired and cannot refresh an access token, and thus redirects to the logout route
  TOKEN_REFRESH_EXPIRED_REDIRECT_TO_LOGOUT = 'TOKEN_REFRESH_EXPIRED_REDIRECT_TO_LOGOUT',
  // A request for refreshing access tokens fails
  TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE',
  // A request for refreshing access tokens is made
  TOKEN_REFRESH_REQUEST = 'TOKEN_REFRESH_REQUEST',
  // A request for refreshing access tokens succeeds
  TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS',
  // A user clicks the Compass link in the sign in page
  COMPASS_LINK_CLICKED = 'COMPASS_LINK_CLICKED',
  // A user views the Compass deprecation page
  COMPASS_DEPRECATION_PAGE_VIEWED = 'COMPASS_DEPRECATION_PAGE_VIEWED',
  // A user clicks the Compass deprecation button
  COMPASS_DEPRECATION_BUTTON_CLICKED = 'COMPASS_DEPRECATION_BUTTON_CLICKED',
  // A user copies the Compass deprecation URL to clipboard
  COMPASS_DEPRECATION_URL_COPIED = 'COMPASS_DEPRECATION_URL_COPIED',
}

export type TelemetryContext = {
  [key: string]: string | number | boolean | null | undefined;
  description?: string;
};

export const telemetry = {
  addAction: (actionName: AUTHENTICATION_ACTIONS, context?: TelemetryContext) => {
    datadogRum.addAction(actionName, context);
  },
  addError: (error: Error, context?: TelemetryContext) => {
    datadogRum.addError(error, context);
  },
};
